// Estimate reading time from a TipTap/ProseMirror JSON document (stored as a
// string) or plain text. ~200 words per minute, minimum 1 minute.
const WORDS_PER_MINUTE = 200;

function collectText(node: unknown, out: string[]): void {
  if (!node || typeof node !== "object") return;
  const n = node as { text?: string; content?: unknown[] };
  if (typeof n.text === "string") out.push(n.text);
  if (Array.isArray(n.content)) {
    for (const child of n.content) collectText(child, out);
  }
}

export function readingMinutes(content: string | null | undefined): number {
  if (!content) return 1;
  let text = content;
  // Content is usually a TipTap JSON doc; fall back to treating it as plain text.
  if (content.trimStart().startsWith("{")) {
    try {
      const parts: string[] = [];
      collectText(JSON.parse(content), parts);
      text = parts.join(" ");
    } catch {
      // keep raw string
    }
  }
  const words = text.trim().split(/\s+/).filter(Boolean).length;
  return Math.max(1, Math.round(words / WORDS_PER_MINUTE));
}
